const getAttributesToRetrieve = (): string[] => {
	return [
		'Id',
		'Mix',
		'Title',
		'Album',
		'Composers',
		'Description',
		'Duration',
		'AlbumTrackNumber',
		'Explicit',
		'Vocal',
		'OriginalComposer',
		'IsArrangement',
		'HasStems',
		'MixCount',
		'MixVariation',
		'TempoStart',
		'TempoFinish',
		'Metre',
		'TempoName',
		'KeyStart',
		'KeyFinish',
		'Lyrics',
		'Isrc',
		'Publishers',
		'Iswc',
		'ReleaseDate',
		'ReleaseYear',
	]
}

export { getAttributesToRetrieve }
